module.exports = __webpack_public_path__ + "img/icon-bin.86988c55.svg";